<template>
    <div class="mb-4 p-4 min-h-12 text-text-secondary">
        <h1 class="text-text-primary text-2xl font-bold">{{ props.crumbs[props.crumbs.length-1].name }}</h1>
        <div class="flex">
            <div class="flex flex-col justify-center">
                <div class="flex items-center">
                    <div v-for="(crumb, index) in props.crumbs" :class="{'font-bold' : index == 0}" class="text-md flex items-center">
                        
                        <NuxtLink class="hover:text-accent" :to="`/dashboard/client-${useSelectedClient.client_id}/screens`" v-if="index == 0">{{ useSelectedClient.name }}</NuxtLink>
                        <UIcon v-if="index == 0" name="i-heroicons-chevron-right"></UIcon>
                        <NuxtLink  class="hover:text-accent" :to="`/dashboard/client-${useSelectedClient.client_id}/website-${useSelectedWebsite.id}`" v-if="index == 0">{{ useSelectedWebsite.name }}</NuxtLink>
                        <UIcon v-if="index == 0" name="i-heroicons-chevron-right"></UIcon>
                        
                        <div class="flex items-center" v-if="crumb.name">
                        <NuxtLink class="hover:text-primary" v-if="crumb.link && index+1 < crumbs.length" :to="`${crumb.link}`">{{ crumb.name }}</NuxtLink>
                        <span v-else>{{ crumb.name }}</span>
                        <UIcon v-if="(crumbs.length > 1 && (crumbs[index+1]?.name && crumbs[index+1]?.name != ''))" name="i-heroicons-chevron-right" />
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script lang="ts" setup>
import type { ClientList } from '~/types/api/user';
import type { Website } from '~/types/api/client/index'

interface crumb {
    name: string,
    link: string,
}

const props = defineProps<{ crumbs: crumb[] }>();

const useSelectedClient = useState<ClientList>('selectedClient')
const useSelectedWebsite = useState<Website>('selectedWebsite');

</script>